module.exports = __webpack_public_path__ + "img/yongwang-bg.7c3f6313.png";